import { sortByOrder } from "lib/utils/common";
import { clone, type } from "ramda";
import {
	QuestionResponseType,
	ResponseChoiceType,
} from "lib/types/personality";
import { post } from "../api";
import getConfig from "next/config";
import { useMutation } from "react-query";

const { publicRuntimeConfig } = getConfig();
const { BASE_URL } = publicRuntimeConfig;

// Question Type reference:
//     QUESTION_TYPE_SEPARATOR = 0
//     QUESTION_TYPE_SCALE = 1
//     QUESTION_TYPE_RADIO = 2
//     QUESTION_TYPE_CHECKBOX = 3
//     QUESTION_TYPE_TEXT = 4
//     QUESTION_TYPE_BOOLEAN = 5
//     QUESTION_TYPE_HORIZONTAL_SLIDER = 6
//     QUESTION_TYPE_VERTICAL_SLIDER = 7
//     QUESTION_TYPE_CARD_RADIO = 8

export type QuestionGroupType = {
	id: number;
	text: string;
	questions: Array<QuestionType>;
};

export type QuestionType = {
	id: number;
	idx: number | null;
	text: string;
	type: number;
	choices: Array<ResponseChoiceType>;
	answer: string | null;
	image: {
		url: string;
	} | null;
	event_name: string | null;

	color?: string;
	completionPercentage?: number;
	remainingTimeText?: string;
};

export type UserMetaDataType = {
	name?: string;
	email?: string;
	phone_number?: string;
	pronouns?: string;
	age?: string;
};

export function transformQuestion(qR: QuestionResponseType) {
	const q: QuestionType = {
		id: qR.id,
		idx: null,
		type: qR.type,
		text: qR.text,
		choices: [],
		answer: null,
		image: qR.image,
		event_name: qR.event_name || null,
	};
	if (q.type !== 0)
		q.choices = qR.response_choice_group.response_choices.sort(sortByOrder);
	return q;
}

export function groupQuestions(qs: Array<QuestionType>) {
	let currentIdx = 0;
	return qs.reduce((acc, q) => {
		if (q.type === 0) {
			const group: QuestionGroupType = {
				id: q.id,
				text: q.text,
				questions: [],
			};
			return [...acc, group];
		}
		const [lastGroup]: Array<QuestionGroupType> = acc.slice(-1);
		const question = { ...clone(q), idx: currentIdx };
		lastGroup.questions.push(question);
		currentIdx++;
		return acc;
	}, [] as Array<QuestionGroupType>);
}

export const linkUser = (): Promise<any> => {
	return post(
		`/surveys/link-user`,
		{},
		{
			baseURL: `${BASE_URL}/api/v1`,
		}
	);
};

export const useLinkUser = ({
	onError,
	onSuccess,
}: {
	onSuccess?: () => void;
	onError?: (err: any) => void;
}) => {
	return useMutation(linkUser, {
		retry: 1,
		onSuccess,
		onError,
	});
};
